import parseQuiz from '@/comp/exercise-copy-paste/quiz';
import parseReflection from '@/comp/exercise-copy-paste/reflection';
import { ref } from 'vue';
import { Exercise } from '@ilteducation/exercise-service-types';

export const parsedExercises = ref<Partial<Exercise>[]>([]);
const extractExerciseType = (value: string): string =>
  value
    .replace(/[^a-zA-z ]/g, '')
    .toLowerCase()
    .trim()
    .replace(' ', '-');

const useExerciseCopyPaste = (parsedCallback: () => void) => {
  const parse = (data: Document) => {
    parsedExercises.value = [];
    const tablesOfContents = data.body.querySelectorAll('tbody');
    tablesOfContents.forEach((tableOfContents) => {
      if (tableOfContents) {
        const type = extractExerciseType(tableOfContents.querySelector('td')!.innerText);
        const rows = Array.from(tableOfContents.querySelectorAll('tr').values()).slice(1);
        if (type === 'quiz') {
          parsedExercises.value = parseQuiz(rows);
        } else if (type === 'questions') {
          // The reflection questions template has a single "Questions" header cell.
          parsedExercises.value = parseReflection(rows);
        }
      }
    });
  };
  const pasteHandler = (pastedEvent: any) => {
    const pastedData = new DOMParser().parseFromString(
      (pastedEvent.clipboardData || (<any>window).clipboardData).getData('text/html'),
      'text/html',
    );
    parse(pastedData);
    parsedCallback();
  };
  const clipboardHandler = async () => {
    if (document.visibilityState === 'visible') {
      try {
        const clipboardItems = await navigator.clipboard.read();
        const htmlInput = await clipboardItems[clipboardItems.length - 1].getType('text/html');
        const htmlString = await htmlInput.text();
        const document = new DOMParser().parseFromString(htmlString, 'text/html');
        parse(document);
        parsedCallback();
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error('Failed to read from clipboard', err);
      }
    } else {
      // user has left the tab
    }
  };

  const toggle = (enabled: boolean) => {
    if (enabled) {
      document.addEventListener('paste', pasteHandler, true);
      if (document.visibilityState === 'visible') {
        navigator.clipboard.read().then(() => {
          // ask for permissions
        });
      }
      document.addEventListener('visibilitychange', clipboardHandler, true);
    } else {
      document.removeEventListener('paste', pasteHandler, true);
      document.removeEventListener('visibilitychange', clipboardHandler, true);
    }
  };

  return {
    parsedExercises,
    toggle,
    parse,
    clipboardHandler,
  };
};

export default useExerciseCopyPaste;
